import * as antlr from './antlr';
import * as cookie from './cookie';
import * as hooks from './hooks';
import * as localStorage from './localStorage';
import * as mobile from './mobile';
import * as webSockets from './web-sockets';

// Примечание: делайте импорты в подобном стиле, чтобы добавить namespace.
// Он нужен, потому что тут будет много утил. И эти утилы могут иметь одинаковые/похожие имена
export {
  webSockets,
  antlr,
  cookie,
  mobile,
  localStorage,
  hooks,
};
